import { useContext, useEffect, useState } from "react";
import AuthContext from "../contexte/AuthContext";
import GoogleLoginComposant from "../pages/googleLogin/GoogleLogin";
import NotAllowed from "../components/NotAllowed";

const ProtectedRoutes = ({ role = [], children }) => {
  const { user, verifyUser } = useContext(AuthContext);
  const [verificationResult, setVerificationResult] = useState(null);

  useEffect(() => {
    if (user) {
      const result = verifyUser();
      setVerificationResult(result);
    } else {
      setVerificationResult(null);
    }
  }, [user, verifyUser]);

  if (user && verificationResult?.access && role.includes(verificationResult?.role)) {
    return children;
  }
  if (user) {
    return <NotAllowed />;
  }
  return <GoogleLoginComposant />;
};

export default ProtectedRoutes;